import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as $ from "jquery"
import * as _ from "lodash";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class SchedulingProjectCalendarScheduleComponent implements IController {
  timeZone: any;
  minDate: any;
  maxDate: any;
  events: any;
  views: any;
  defaultView: any;
  columnFormat: any;
  firstDay: any;
  height: any;
  canCreate: any;
  slotDuration: any;
  slotLabelInterval: any;
  isSelectable: any;
  canEdit: any;
  showTitle: any;
  displayEventsTime: any;
  eventLimit: any;
  addButton: any;
  onAdd: Function
  onClick: Function
  onDaysSelect: Function
  onEventChange: Function
  onBeforeDrop: Function
  onDayDoubleClick: Function
  onViewRender: Function
  onViewDestroy: Function


  timeFormat;
  eventSources;
  calendarOptions;
  doubleClick;
  clickTimer;
  private $recurringIcon: any;
  private $timeZoneIcon: any;

  constructor(private confirmDialogService: ConfirmDialogService,
              private $timeout: ITimeoutService,
              private uiCalendarConfig, private $log, private splitService, private $filter, private moment) {
    this.$recurringIcon = document.createElement('IMG');
    this.$recurringIcon.setAttribute("src", 'assets/images/icons/v2/recurring.svg');
    this.$recurringIcon.classList.add('icon', 'bringoz-icon');

    this.$timeZoneIcon = document.createElement('IMG');
    this.$timeZoneIcon.setAttribute("src", 'assets/images/icons/v2/time-zone.svg');
    this.$timeZoneIcon.classList.add('icon', 'bringoz-icon-small');
  }

  $onInit() {

    this.timeFormat = this.splitService.getDateAndTimeConfig().time;

    this.eventSources = [this.events];

    this.calendarOptions = {
      height: this.height || 'auto',
      // contentHeight: 'auto',
      // handleWindowResize: true,
      resourceAreaWidth: 230,
      // timezone: this.timeZone || 'local', // NOT WORKING. WORKAROUND IN DAYS SELECT
      timezone: this.splitService.getTimeZone(),
      nowIndicator: true,
      selectable: this.isSelectable || false,
      eventLimit: this.eventLimit || true, // boolean or number
      editable: this.canEdit || false,
      eventStartEditable: this.canEdit || false,
      eventLimitText: "More Events",
      header: {
        // left: this.getExtraActions(this.views),
        left: this.showTitle ? 'prev,title,next' : undefined,
        center: '',
        // right: 'listWeek,month,agendaWeek,agendaDay'
        right: ''
      },
      defaultView: this.defaultView || 'month',
      buttonText: {
        today: this.$filter('translate')('Today'),
        month: this.$filter('translate')('Month'),
        week: this.$filter('translate')('Week'),
        day: this.$filter('translate')('Day'),
        list: this.$filter('translate')('List'),
      },
      customButtons: this.getCustomButtons(this.canCreate && this.addButton),
      allDaySlot: false,
      displayEventTime: !_.isUndefined(this.displayEventsTime) ? this.displayEventsTime : true,
      displayEventEnd: !_.isUndefined(this.displayEventsTime) ? this.displayEventsTime : true,
      // columnFormat: 'ddd DD/MM',
      columnFormat: {
        week: this.columnFormat,
      },
      slotLabelFormat: this.timeFormat,
      timeFormat: this.timeFormat,
      slotDuration: this.slotDuration || "01:00:00",
      slotLabelInterval: this.slotLabelInterval || "02:00:00",
      firstDay: this.firstDay || 0,
      eventClick: this.eventClick.bind(this),
      select: this.selectDays.bind(this),
      dayClick: this.dayClick.bind(this),
      eventResize: this.eventResize.bind(this),
      eventDrop: this.eventDrop.bind(this),
      eventRender: this.eventRender.bind(this),
      viewRender: this.viewRender.bind(this),
      viewDestroy: this.viewDestroy.bind(this)
      // eventAllow: function(dropLocation, draggedEvent) {}
      // viewRender : viewRender,
      // drop: function() {},
    };

  }

  $onChanges(changes) {
    if (changes.events && !changes.events.isFirstChange()) {
      this.uiCalendarConfig.calendars.calendar.fullCalendar('removeEventSources');
      this.uiCalendarConfig.calendars.calendar.fullCalendar('removeEvents');
      this.eventSources.length = 0;
      this.eventSources.push(changes.events.currentValue);

      // this.eventSources = [changes.events.currentValue];
    }
    if (changes.height && !changes.height.isFirstChange()) {
      this.calendarOptions.height = this.height;
    }
    if (changes.canEdit && !changes.canEdit.isFirstChange()) {
      this.calendarOptions.editable = this.canEdit;
      this.calendarOptions.eventStartEditable = this.canEdit;
    }

    if (changes.eventLimit && !changes.eventLimit.isFirstChange()) {
      this.calendarOptions.eventLimit = this.eventLimit;
    }

    if (changes.defaultView && !changes.defaultView.isFirstChange()) {
      this.calendarOptions.defaultView = this.defaultView;
    }
  }

  getExtraActions(views) {
    let stringViews = '';
    _.forEach(views, (v) => {
      stringViews += v + ','
    });

    if (this.addButton) {
      stringViews += ' add';
    }
    return stringViews;
  }

  getCustomButtons(enabled) {
    return enabled ? {
      add: {
        text: '+',
        click: () => {
          this.onAdd();
        }
      }
    } : {};
  }

  private eventClick(calEvent, jsEvent, view) {
    this.onClick({event: calEvent, $event: jsEvent});
  }

  private selectDays(from, to, jsEvent, view) {

    // test to check if is full day selection and change it to day before

    // var test = moment(from).tz(ctrl.timeZone);
    if (!from.hasTime() || !to.hasTime()) {
      from = this.moment(from.toISOString());
      to = this.moment(to.toISOString()).subtract(1, 'day').endOf('day');

      // from = this.moment(this.moment(from).format("YYYY-MM-DD HH:mm:SS"));
      // to = this.moment(this.moment(to).format("YYYY-MM-DD HH:mm:SS")).subtract(1, 'day').endOf('day');

      // from = this.moment(from).local().startOf('day');
      // to = this.moment(to).local().subtract(1, 'day').endOf('day');
    }

    const selectedDaysEvents = _.filter(this.events, e => {
      const start = this.moment(e.start);
      const end = this.moment(e.end);

      if (!start.isValid() || !end.isValid()) {
        return false;
      }

      const eventAllDatesInRange = this.getAllDatesInRange(start, end);

      return _.filter(eventAllDatesInRange, date => {
        return date === this.moment(from).valueOf() ||
          date === this.moment(to).valueOf() ||
          this.moment(date).isBetween(from, to);
      }).length > 0;

    });

    from = this.moment(from.toISOString());
    to = this.moment(to.toISOString());

    this.onDaysSelect({from: from, to: to, events: selectedDaysEvents})
  }

  private dayClick(date, allDay, jsEvent, view) {
    const singleClick = new Date(date).toUTCString();
    if (this.doubleClick == singleClick) {
      this.doubleClick = null;
      this.onDayDoubleClick({date: date = this.moment(date.format("YYYY-MMM-DD HH:mm:SS"))});
    } else {
      this.doubleClick = new Date(date).toUTCString();
      clearInterval(this.clickTimer);
      this.clickTimer = setInterval(() => {
        this.doubleClick = null;
        clearInterval(this.clickTimer);
      }, 500);
    }
  }

  private eventResize(event, delta, revertFunc) {
    // event.start = moment(event.start.format());
    // event.end = moment(event.end.format());
    this.onEventChange({event: event, delta: delta, revertFunc: revertFunc})

    // var title =_.get(event, 'title');
    //  ConfirmDialog.confirm('Change Event' + (title ? ' - ' + title : ''), 'are you sure you want to change event?')
    //      .then(function() {
    //          event.start = moment(event.start.format());
    //          event.end = moment(event.end.format());
    //          ctrl.onEventChange({event: event, delta: delta})
    //      })
    //      .catch(function(error) {
    //          if (error) {
    //              $log.error(error);
    //          } else {
    //              revertFunc();
    //          }
    //      })
  }

  private eventDrop(event, delta, revertFunc) {
    const eventCopy = angular.copy(event);
    eventCopy.start = this.moment(event.start.format());
    eventCopy.end = this.moment(event.end.format());
    this.onEventChange({event: eventCopy, delta: delta, revertFunc: revertFunc})
  }

  private eventRender(event, element) {


    element.find('.fc-title').each(() => {
      $(this).insertBefore($(this).prev('.fc-time'));
    });


    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(event.zoneId, event.notBefore);

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      const timeZoneIcon = this.$timeZoneIcon.cloneNode(true);
      timeZoneIcon.classList.add('white', 'margin-left-0');
      const text = ` ${this.$filter('timeWindow')({
        notBefore: event.notBefore,
        notAfter: event.notAfter
      }, event.zoneId)}`;
      // element.find(".fc-title").prepend(repeatIcon + text);

      const timeZoneDiv = document.createElement('div');
      timeZoneDiv.classList.add("time-zone-container");

      const timeZoneSpan = document.createElement("span");
      timeZoneSpan.textContent = `${event.zoneId} ${text}`;
      timeZoneDiv.insertAdjacentElement('beforeend', timeZoneIcon);
      timeZoneDiv.insertAdjacentElement('beforeend', timeZoneSpan);


      element.find(".fc-title").append(timeZoneDiv);
    }

    const isRecurring = !!event.dataRef?.templateId && !event.dataRef?.template && !event.dataRef?.overridden;

    if (isRecurring) {
      const repeatIcon = this.$recurringIcon.cloneNode(true);
      repeatIcon.classList.add('white', 'margin-left-0');
      element.find(".fc-time").prepend(repeatIcon);
    }

    if (!event.ranges) {
      return true;
    }

    // if (event.exceptions && event.exceptions.length) {
    //     _.forEach(event.exceptions, function(excludeDate) {
    //         if (moment(excludeDate).isSame(moment(event.start), 'date')) {
    //             return false;
    //         }
    //     });
    // }

    return (event.ranges.filter(range => { // test event against all the ranges

      if (!event.start || !event.end) {
        return false;
      }

      return (event.start.isBefore(range.end) &&
        event.end.isAfter(range.start));
    }).length) > 0;
  }

  private viewRender(currentView) {
    if (this.minDate && this.maxDate) {
      const navigationContainer = currentView.el.parent().prev();
      const cantGoBefore = currentView.start.format("YYYY-MM-DD") <= this.moment(this.minDate).format("YYYY-MM-DD");
      const cantGoAfter = currentView.end.format("YYYY-MM-DD") > this.moment(this.maxDate).format("YYYY-MM-DD");

      $(".fc-prev-button", navigationContainer).prop('disabled', cantGoBefore);
      $(".fc-prev-button", navigationContainer).toggleClass('fc-state-disabled', cantGoBefore);
      $(".fc-next-button", navigationContainer).prop('disabled', cantGoAfter);
      $(".fc-next-button", navigationContainer).toggleClass('fc-state-disabled', cantGoAfter);
    }

    // const start = moment(currentView.start).local().startOf('day');
    // const end = moment(currentView.end).local().subtract(1, 'day').endOf('day');

    const start = this.moment(currentView.start.format("YYYY-MM-DD HH:mm:SS")).startOf('day');
    const end = this.moment(currentView.end.format("YYYY-MM-DD HH:mm:SS"));
    // const end = this.moment(currentView.end.format("YYYY-MM-DD HH:mm:SS")).endOf('day');


    this.callCycle()
      .then(() => {
        this.onViewRender({start: start, end: end, view: currentView});
      })
  }

  private viewDestroy() {
    this.onViewDestroy();
  }

  private getAllDatesInRange(start, end) {
    let dates = [];
    const checkDate = start.startOf('day');

    while (checkDate.isBefore(end) || checkDate.isSame(end)) {
      dates.push(checkDate.valueOf());
      checkDate.add(1, 'days');
    }
    return dates;
  }

  private callCycle() {
    return this.$timeout(0)
  }


}

angular
  .module('bringoz.admin.scheduling-project')
  .component('schedulingProjectCalendarSchedule', {
    bindings: {
      timeZone: '<?',
      minDate: '<?',
      maxDate: '<?',
      events: '<',
      views: '<',
      defaultView: '@?',
      columnFormat: '<',
      firstDay: '<?',
      height: '<?',
      canCreate: '<?',
      isSelectable: '<?',
      slotDuration: '<',
      slotLabelInterval: '<',
      canEdit: '<?',
      showTitle: '@?',
      displayEventsTime: '<?',
      eventLimit: '<?',
      addButton: '<?',
      onAdd: '&',
      onClick: '&',
      onDaysSelect: '&',
      onEventChange: '&',
      onBeforeDrop: '&',
      onDayDoubleClick: '&',
      onViewRender: '&',
      onViewDestroy: '&'
    },
    template: require('./scheduling-project-calendar-schedule.html').default,
    controller: SchedulingProjectCalendarScheduleComponent
  });
